<template>
  <hm-content title="">
    <div class="flex flex-between item-center">
      <div>
        <el-button type="primary" size="small" @click="add">充值短信</el-button>
      </div>
      <div style="fontSize:16px;fontWeight:600">
        当前可用余额: <span class="primary">{{ purchaseNumber }}</span> 条
      </div>
    </div>
    <div>
      <div class="flex flex-center">
        <div class="ts">
          <div>
            <span
              class="hmicon icon-tishi"
              style="color:rgb(243, 174, 64)"
            ></span>
            禁止发送色情、赌博、暴力、侵权及其他违法信息
          </div>
          <div class="ml20">
            金融、教育、房地产、移民、建材游戏营销行业暂不支持发送
          </div>
        </div>
      </div>
      <div class="flex flex-center mt20 mb20">
        <div class="ts">
          <div>
            <span>温馨提示：</span>
            1、需要约1个小时的时间进行发送准备，请提前提交;
          </div>
          <div style="marginLeft:74px">
            2、为保障您的营销短信发送成功率，建议发送100条以上的短信;
          </div>
          <div style="marginLeft:74px">
            3、逢双十一、电商活动和节假日期间，发送最大，部分短信可能会出现短时间发送延迟，尽请谅解!
          </div>
        </div>
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      >
        <el-form-item label="任务标题:" prop="taskTitle">
          <el-input
            size="small"
            clearable
            style="width:300px"
            class="mr10 ipt"
            maxlength="20"
            v-model.trim="ruleForm.taskTitle"
            placeholder="请输入任务标题，最多输入20个字"
          ></el-input>
        </el-form-item>
        <el-form-item label="发送方式:" prop="state">
          <el-radio-group
            v-model="ruleForm.state"
            size="small"
            @change="stateChange"
          >
            <el-radio label="input">输入号码发送 </el-radio>
            <el-radio label="import">导入号码发送</el-radio>
            <el-button
              type="text"
              size="small"
              v-if="ruleForm.state === 'import'"
              @click="outputExcel"
              >导出模板</el-button
            >
            <el-button
              type="text"
              size="small"
              class="open-file"
              v-if="ruleForm.state === 'import'"
              >上传文件
              <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </el-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="输入号码:"
          prop="inputMobiles"
          v-if="ruleForm.state === 'input'"
        >
          <el-input
            type="textarea"
            style="width:300px"
            placeholder="请输入内容"
            v-model="ruleForm.inputMobiles"
          >
          </el-input>
          <div class="form-item-tip">
            手动输入，一行一个号码，回车切换下一行，
          </div>
          <div class="form-item-tip">
            每次最多能提交2000个号码。建议50个号码以上的用文件导入提交
          </div>
        </el-form-item>
        <el-form-item
          label="导入号码:"
          prop="memberMobiles"
          v-if="ruleForm.state === 'import'"
        >
          <div
            class="ecxel pointer flex flex-between"
            v-if="ruleForm.memberMobiles.length"
          >
            <div style="color: #606266;" class="flex item-center">
              <span class="hmicon icon-xls" style="marginRight:5px"> </span>
              <el-tooltip placement="top" :content="excelName">
                <div class="excel-name">{{ excelName }}</div>
              </el-tooltip>
            </div>
            <div>
              <!-- <i class="el-icon-circle-check success"></i> -->
              <i class="el-icon-close" @click="remove"></i>
            </div>
          </div>
          <!-- <div
            style="height:500px;width:300px"
            v-if="ruleForm.memberMobiles.length"
          >
            <el-scrollbar style="height:100%" class="page-component__scroll">
              <el-table
                stripe
                border
                size="small"
                :data="ruleForm.memberMobiles"
              >
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column
                  label="导入号码"
                  header-align="center"
                  align="center"
                  prop="phone"
                >
                </el-table-column>
                <el-table-column
                  label="操作"
                  header-align="center"
                  align="center"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="remove(scope.$index)"
                        >删除</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-scrollbar>
          </div> -->
        </el-form-item>
        <el-form-item label="编辑内容:" prop="smsContent">
          <div style="lineHeight: 14px;" class="mt10">[{{ label }}]</div>
          <el-input
            type="textarea"
            style="width:300px"
            placeholder="请输入内容"
            :autosize="{ minRows: 4 }"
            v-model="ruleForm.smsContent"
            @input="phoneLength"
          >
          </el-input>
          <div style="width:300px;lineHeight: 14px;" class="flex flex-end">
            拒收请回复R
          </div>
          <div class="form-item-tip">
            *提示:发送内容为 [<span class="primary">{{
              contentLength * 1 + 6
            }}</span
            >]字 | 发送条数为 [<span class="primary">{{ contentRow }}</span
            >]条 | 每条短信按照 [70]个字计费 |
          </div>
          <div class="form-item-tip">企业签名:[{{ label }}]</div>
          <div class="form-item-tip">
            *营销短信格式:【签名】+内容+拒收请回复R
          </div>
        </el-form-item>
      </el-form>
      <div class="flex flex-center">
        <el-button type="primary" size="small" @click="submitForm('ruleForm')"
          >立即发送</el-button
        >
      </div>
    </div>
    <el-dialog
      title="充值短信"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
    >
      <div>
        <div class="mb10 cz-header">
          充值
        </div>
        <div class="flex flex-wrap mb20">
          <div
            class="preview pointer p10"
            :class="{ active: active === v.id }"
            v-for="(v, i) in storeSmsConfigList"
            :key="i"
            @click="conversion(v)"
          >
            <img
              v-if="active === v.id"
              class="active-img"
              src="https://imgcdn.hemiao100.com/ThemePictures/1.png"
              alt=""
            />
            <div class="flex flex-center rechargeAmount">
              {{ v.rechargeAmount }}元
            </div>
            <div class="flex flex-center rechargeAmount">
              {{ v.rechargeNum }}条
            </div>
            <!-- <hr /> -->
            <div class="dashed"></div>
            <div class="flex flex-center item-center" style="height:37px">
              低至{{ v.averagePrice }}元/条
            </div>
          </div>
        </div>

        <div style="fontSize:16px" class="flex flex-wrap item-center">
          <div class="cz-header mr20">
            价格
          </div>
          <div class="primary mr10">¥{{ activeRow.rechargeAmount }}</div>
          <div>
            原价：<span style="text-decoration:line-through;">{{
              activeRow.originalPrice
            }}</span>
          </div>
        </div>
      </div>
      <span slot="footer">
        <div class="dialog-footer flex flex-center">
          <el-button @click="shopping" size="small" type="primary"
            >立即购买</el-button
          >
          <el-button @click="dialogVisible = false" size="small" type="info"
            >取 消</el-button
          >
        </div>
        <div class="flex flex-center">
          <div style="width:500px">
            <div class="form-item-tip flex flex-center">
              *短信包不支持退款，请确认后购买
            </div>
            <div class="form-item-tip flex flex-start">
              1、短信内容不允许涉及政治、色情、暴力、侵权、赌博以及其他违法信息
            </div>
            <div class="form-item-tip flex flex-start">
              2、短信属于公众服务,受国家政策法规限制，具体审核结果，以短信平台审核结果为准
            </div>
            <div class="form-item-tip flex flex-start">
              3、股票,游戏,出国，医疗器械，代理，珠宝，保健品，茶叶，KTV,养生足浴SPA,皮
            </div>
            <div class="form-item-tip flex flex-start">
              草,A货，奢饰品，金融，教育,房产，兼职招聘，装修装饰，资质代办，培训，会议邀
            </div>
            <div class="form-item-tip flex flex-start">
              约、买卖手机、以旧换新、流量话费类等涉及以上行业内容营销短信暂不支持发送
            </div>
          </div>
        </div>

        <!-- <el-button @click="dialogVisible = false" size="small">关闭</el-button> -->
      </span>
      <el-dialog
        width="30%"
        title="付款码"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="form-tip">请使用微信或支付宝扫码支付</div>
        <div class="text-center">
          <img class="paycode" :src="payCodeUrl" alt="付款码" />
        </div>
      </el-dialog>
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div>
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误未导入
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            prop="phone"
            label="错误及重复手机号"
          ></el-table-column>
          <!-- <el-table-column prop="mobile" label="手机号"></el-table-column> -->
        </el-table>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import QRCode from "qrcode";
import XLSX from "xlsx";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    const patternLocation = function(rule, val, callback) {
      if (this.ruleForm.state === "input") {
        let flag = false;

        this.ruleForm.inputMobiles.split(/[(\r\n)\r\n]+/).forEach(v => {
          if (v !== "") {
            if (!/^1[3-9]\d{9}$/.test(v.replace(/\s*/g, ""))) {
              flag = true;
            }
          }
        });
        if (flag) {
          return callback(new Error("请输入正确手机号!"));
        }
      }

      callback();
    }.bind(this);
    const importFun = function(rule, val, callback) {
      if (this.ruleForm.state === "import") {
        if (!this.ruleForm.memberMobiles.length) {
          return callback(new Error("请导入号码!"));
        }
      }

      callback();
    }.bind(this);
    return {
      terminal_trace: "",
      innerVisible: false,
      payCodeUrl: "",
      socket: "",
      activeRow: {},
      active: "",
      storeSmsConfigList: [],
      purchaseNumber: 0,
      label: "",
      errValidGoods: false,
      errInputResult: [],
      dialogVisible: false,
      contentLength: 0,
      contentRow: 0,
      ruleForm: {
        taskTitle: "",
        state: "input",
        smsContent: "",
        memberMobiles: [],
        inputMobiles: "",
        smsNum: 0
      },
      rules: {
        taskTitle: {
          required: true,
          message: "请输入任务标题",
          trigger: "blur"
        },
        inputMobiles: [
          {
            required: true,
            message: "请输入电话号码",
            trigger: "blur"
          },
          {
            required: true,
            validator: patternLocation,
            trigger: "blur"
          }
        ],
        memberMobiles: {
          required: true,
          validator: importFun,
          trigger: "blur"
        },
        smsContent: {
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }
      },
      excelName: ""
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryMsgNum();
    this.queryMsgName();
  },
  destroyed() {
    // 销毁监听
    if (typeof this.socket === "object") {
      this.socket.close();
    }
  },
  methods: {
    remove() {
      this.ruleForm.memberMobiles = [];
      this.excelName = "";
    },
    stateChange(val) {
      if (val === "input") {
        this.ruleForm.memberMobiles = [];
      } else {
        this.ruleForm.inputMobiles = "";
      }
    },
    async queryMsgName() {
      const { result } = await this.$store.dispatch("querySmsSignature");
      this.label = result;
      this.contentLength = result.length;
      this.contentRow = Math.ceil((result.length + 6) / 70);
    },
    reset() {
      this.dialogVisible = false;
      this.innerVisible = false;
      this.activeRow = {};
      this.active = "";
      this.$message({
        message: "充值成功",
        type: "success"
      });
    },
    getMessage(msg) {
      console.log("msg: ", msg);
      const originData = msg.data;
      if (originData) {
        const { code, data } = JSON.parse(originData);
        if (code === "0") {
          if (data === this.terminal_trace) {
            this.reset();
            this.socket.close();
            this.queryMsgNum();
            this.queryMsgName();
          }
        }
      }
    },
    init() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持socket");
      } else {
        // 实例化socket
        this.socket = new WebSocket(this.$wsAddress);
        // 监听socket连接
        this.socket.onopen = this.open;
        // 监听socket错误信息
        this.socket.onerror = this.error;
        // 监听socket消息
        this.socket.onmessage = this.getMessage;
      }
    },
    open() {},
    error() {},
    async shopping() {
      const { code, result } = await this.$store.dispatch(
        "smsRecharge",
        this.activeRow
      );

      if (code === "0") {
        const { message } = result;
        this.innerVisible = true;
        QRCode.toDataURL(message.qr_url)
          .then(payCodeUrl => {
            this.payCodeUrl = payCodeUrl;
            this.innerVisible = true;
            this.terminal_trace = result.message.terminal_trace;
            this.init();
          })
          .catch(err => {
            throw new Error(err);
          });
        // this.$message({
        //   message: "充值成功",
        //   type: "success"
        // });
      }
    },
    async queryMsgNum() {
      const { result } = await this.$store.dispatch("queryStoreMessageNum");
      this.purchaseNumber = result.purchaseNumber;
    },
    async queryStoreSmsConfigList() {
      const { result } = await this.$store.dispatch("queryStoreSmsConfigList");
      this.storeSmsConfigList = result;
      this.active = result[0].id;
      this.activeRow = result[0];
    },
    conversion(v) {
      this.active = v.id;
      this.activeRow = v;
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
        this.excelName = "";
        this.ruleForm.memberMobiles = [];
      }, 0);
    },
    add() {
      this.queryStoreSmsConfigList();
      this.dialogVisible = true;
    },
    phoneLength(val) {
      let length = val.length + this.label.length;
      this.contentLength = length;
      this.contentRow = Math.ceil((length + 6) / 70);
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["手机号"];
        const data = [["12345678911"], ["12345678912"]];

        exportJsonToExcel(tHeader, data, "模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();

      this.excelName = f.name;
      reader.onload = function(e) {
        let data = e.target.result;

        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }

        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });

          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        // let isValid = true;
        // let isRequired = true;
        // let goodsSns = [];
        result.forEach(v => {
          if (/^1[3-9]\d{9}$/.test(v[0])) {
            formatResult.push({
              phone: v[0] + ""
            });
          } else {
            that.errInputResult.push({
              phone: v[0]
            });
          }
          // if (!v[0] || !v[1] || !v[2]) {
          //   isRequired = false;
          // } else {
          //   if (!that.isString(v[1]) || !that.isString(v[2])) {
          //     isValid = false;
          //     //   that.errValidGoods = true;
          //     //   that.errInputResult.push({
          //     //     name: v[0],
          //     //     mobile: v[1]
          //     //   });
          //   } else {
          //     goodsSns.push(v[0]);
          //     formatResult.push({
          //       phone: v[0] + ""
          //     });
          //   }
          // }
        });
        if (formatResult.length) {
          let errList = formatResult.filter((item, index, self) => {
            for (let i = index + 1; i < self.length; i++) {
              if (self[i].phone === item.phone) {
                return true;
              }
            }
            return false;
          });
          let successList = that.unique(formatResult);
          that.errInputResult.push(...errList);
          that.ruleForm.memberMobiles = successList;
        }
        if (that.errInputResult.length) {
          that.errValidGoods = true;
        }

        // if (isValid && isRequired) {
        //   let errList = formatResult.filter((item, index, self) => {
        //     for (let i = index + 1; i < self.length; i++) {
        //       if (self[i].goodsSn === item.goodsSn) {
        //         return true;
        //       }
        //     }
        //     return false;
        //   });

        //   if (errList.length > 0) {
        //     that.errValidGoods = true;
        //     that.errInputResult = errList;
        //     that.$message({
        //       message: "导入失败，有重复商品货号！",
        //       type: "warning"
        //     });
        //   } else {
        //     // that.$store
        //     //   .dispatch("queryShareGoodsSn", { goodsSns })
        //     //   .then(res => {
        //     //     const { code, result } = res;
        //     //     if (code === "0") {
        //     //       if (result.resultList.length > 0) {
        //     //         that.distributionGoodList = [];
        //     //         result.resultList.forEach(v => {
        //     //           formatResult.forEach(item => {
        //     //             if (v.goodsSn === item.goodsSn) {
        //     //               that.distributionGoodList.push(
        //     //                 Object.assign({}, item, v)
        //     //               );
        //     //             }
        //     //           });
        //     //         });
        //     //       }
        //     //       if (result.errGoodsSns.length > 0) {
        //     //         that.errValidGoods = true;
        //     //         that.errInputResult = [];
        //     //         result.errGoodsSns.forEach(v => {
        //     //           that.errInputResult.push({ goodsSn: v });
        //     //         });
        //     //       }
        //     //     }
        //     //   });
        //   }
        // } else {
        //   if (!isRequired) {
        //     that.$message({
        //       message: "导入失败，请导入必填商品信息！",
        //       type: "warning"
        //     });
        //   } else if (!isValid) {
        //     that.$message({
        //       message: "导入失败，日期请使用文本格式导入！",
        //       type: "warning"
        //     });
        //   }
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    unique(arr) {
      const res = new Map();
      return arr.filter(arr => !res.has(arr.phone) && res.set(arr.phone, 1));
    },
    isString(value) {
      return typeof value === "string";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));

          if (params.state === "input") {
            params.memberMobiles = [];

            this.ruleForm.inputMobiles.split(/[(\r\n)\r\n]+/).forEach(v => {
              if (v !== "") {
                params.memberMobiles.push(v.replace(/\s*/g, ""));
              }
            });
          } else {
            let memberMobiles = [];
            params.memberMobiles.forEach(v => {
              memberMobiles.push(v.phone);
            });
            params.memberMobiles = memberMobiles;
          }

          params.smsNum = this.contentRow;
          params.smsContent = params.smsContent + "拒收请回复R";
          this.$store.dispatch("batchSendMessageTargetAccount", params).then(res => {
            if (res.code === "0") {
              this.resetRuleForm();
              setTimeout(() => {
                this.queryMsgNum();
                this.queryMsgName();
              });

              this.$message({
                message: "操作成功",
                type: "success"
              });
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.rechargeAmount {
  color: #000;
  font-size: 16px;
  font-weight: 600;
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.ts {
  // border: 1px solid #e50065;
  padding: 10px;
  //   width: 500px;
  //   height: 40px;
  //   line-height: 15px;
  border: 2px dashed #f7eeee;
  position: relative;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 0, 0, 0.1) inset;
  background-color: #e6eef6;
}
.cz-header {
  color: #222222;
  font-weight: 700;
  font-size: 16px;
  //   line-height: 48px;
}

.ecxel {
  font-size: 18px;
  width: 300px;
  .excel-name {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-icon-close {
    transition: transform 0.5s;
    -moz-transition: -moz-transform 0.5s; /* Firefox 4 */
    -webkit-transition: -webkit-transform 0.5s; /* Safari 和 Chrome */
    -o-transition: -o-transform 0.5s;
  }
}
.ecxel:hover {
  .hmicon {
    color: #e50065;
    transition: all 0.1s ease;
  }
  .excel-name {
    color: #e50065;
    transition: all 0.1s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-icon-close {
    color: #ff0000;
    transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
  }
}

.preview {
  margin: auto 10px;
  box-sizing: border-box;
  width: 150px;
  height: 100px;
  // box-shadow: 0px 3px 32px 0px rgba(221, 221, 221, 0.58);
  // box-shadow: 12px 12px 2px 1px rgba(0, 0, 255, 0.2);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3), 0 0 20px rgba(0, 0, 0, 0.1) inset;
  margin-bottom: 20px;
  position: relative;
  border: 2px dashed #f7eeee;
  .dashed {
    height: 12px;
    border-bottom: 1px dashed #606266;
  }

  &.active {
    opacity: 0.9;
    color: #e50065;
    border: 1px solid #e50065;
  }
  .active-img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
